import axiosInstance from './axios-service';

interface MarkNotificationsResponseData {
  count: number;
}

export const markNotifications = async (
  notificationIds: string[],
  deliveredAt: string
): Promise<MarkNotificationsResponseData> => {
  try {
    const res = await axiosInstance.post('markNotifications', {
      notificationIds,
      deliveredAt
    });
    return res.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error(error);
    }
    throw error;
  }
};
